import { useMemo } from 'react'

import { headersToFooters } from '@views/reports/elements/ReportsPdfDocument/elements/ReportsPdfTable/utils/headersToFooter'

import { mapBalanceSheetBalances } from '../../../../utils/balanceMappers'
import { buildTableData } from '../../../../utils/buildTableData'
import { getHeaderRow, getRowData } from '../utils/balanceSheetCsvFormatters'
import { useBalanceSheetData } from './useBalanceSheetData'

export const useBalanceSheetSpreadSheetExportData = () => {
  const { reportData, allExpandableIds, periods } = useBalanceSheetData()

  const expandedRows = useMemo(
    () => allExpandableIds?.reduce((acc, id) => ({ ...acc, [id]: true }), {}) ?? {},
    [allExpandableIds],
  )

  const tableData = buildTableData(reportData, expandedRows, periods, mapBalanceSheetBalances)
  const sortedData = headersToFooters(tableData)

  const spreadSheetData = useMemo(
    () => [getHeaderRow(periods), ...sortedData.map((row) => getRowData(row, periods))],
    [periods, sortedData],
  )

  return { spreadSheetData }
}
